
export const contactSheetActionTypes = {
    GET_CONTACT_SHEET_SUCCESS: "GET_CONTACT_SHEET_SUCCESS",
    GET_CONTACT_SHEET_LOADING: "GET_CONTACT_SHEET_LOADING",
    GET_CONTACT_SHEET_ERROR: "GET_CONTACT_SHEET_ERROR",
}